export default __webpack_public_path__ + "static/media/ico_lol_light.546c5d0b.svg";